import _ from 'lodash';
import GenericPMSJSONParser from 'app/pms/parser/GenericPMSJSONParser';
import NoParserError from 'app/pms/parser/NoParserError';
import PmsParser, { PmsConfiguration } from 'app/pms/parser/PmsParser';
import { PmsTypes } from 'app/pms/parser/types';
import { AssistoVet } from 'app/pms/exporter/AssistoVetExporter';
import { GmVet } from 'app/pms/exporter/GmVetExporter';
import { VetoPartner } from 'app/pms/exporter/VetoPartnerExporter';
import { VetoWin } from 'app/pms/exporter/VetoWinExporter';
import { FileMaker } from 'app/pms/exporter/FileMakerExporter';

export class AggregatedParser implements PmsParser {
  private currentPmsType: PmsTypes;
  constructor(
    private parsers: Record<PmsTypes, PmsParser> = {
      [AssistoVet.CONFIGURATION_KEY]: new GenericPMSJSONParser(
        AssistoVet.CONFIGURATION_KEY,
        AssistoVet.ORIGIN
      ),
      [GmVet.CONFIGURATION_KEY]: new GenericPMSJSONParser(GmVet.CONFIGURATION_KEY, GmVet.ORIGIN),
      [VetoPartner.CONFIGURATION_KEY]: new GenericPMSJSONParser(
        VetoPartner.CONFIGURATION_KEY,
        VetoPartner.ORIGIN
      ),
      [VetoWin.CONFIGURATION_KEY]: new GenericPMSJSONParser(
        VetoWin.CONFIGURATION_KEY,
        VetoWin.ORIGIN
      ),
      [FileMaker.CONFIGURATION_KEY]: new GenericPMSJSONParser(
        FileMaker.CONFIGURATION_KEY,
        FileMaker.ORIGIN
      ),
    }
  ) {
    this.currentPmsType = undefined;
  }

  parse = (fileContent: string) => {
    const parser = this.parsers[this.currentPmsType];
    if (parser === undefined) {
      throw new NoParserError(
        `No valid parser matching PMSType. Selected PMSType ${this.currentPmsType}`
      );
    }
    return parser.parse(fileContent);
  };

  updateConfiguration = (pmsConfiguration: PmsConfiguration) => {
    this.currentPmsType = pmsConfiguration.type;
    _.forEach(this.parsers, (parser) => parser.updateConfiguration(pmsConfiguration));
  };
}
